import { HateoasResource } from "@lagoshny/ngx-hateoas-client";
import { BaseEntity } from "@app/models/rest/base-entity";
import { ResourceFactMappingPatternEntry } from "./resource-fact-mapping-pattern-entry";

@HateoasResource("resourceFactMappingPatterns")
export class ResourceFactMappingPattern extends BaseEntity {
  description: string;
  length: number;
  patternOrigin: Date;
  patternEntries: ResourceFactMappingPatternEntry[];
}
